/**
 * @Author : Caven Chen
 */

class RadarWaveGreenMaterialProperty {
    constructor(options) {
        this._definitionChanged = new Cesium.Event();
        this._color = undefined;
        this._speed = undefined;
        this.color = (options && options.color) || Cesium.Color.GREEN;
        this.speed = (options && options.speed) || 10.0;
    }

    get isConstant() {
        return false;
    }

    get definitionChanged() {
        return this._definitionChanged;
    }
    getType(time) {
        return Cesium.Material.RadarWaveGreenMaterial_Type
    }

    getValue(time, result) {
        if (!Cesium.defined(result)) {
            result = {};
        }
        result.color = Cesium.Property.getValueOrDefault(this._color, time, Cesium.Color.GREEN, result.color);
        result.speed = Cesium.Property.getValueOrDefault(this._speed, time, 10.0, result.speed)
        return result
    }

    equals(other) {
        return (
            this === other ||
            (other instanceof RadarWaveGreenMaterialProperty &&
                Cesium.Property.equals(this._color, other._color) &&
                Cesium.Property.equals(this._speed, other._speed))
        )
    }
}

Object.defineProperties(RadarWaveGreenMaterialProperty.prototype, {
    color: Cesium.createPropertyDescriptor('color'),
    speed: Cesium.createPropertyDescriptor('speed'),
})

export default RadarWaveGreenMaterialProperty
